module.exports = __webpack_public_path__ + "static/media/arpTable.ff230851.jpg";